<template>
  <div class="flex h-screen overflow-hidden">
    <!---Sidebar-->
    <ReSidebar :sidebarLinks="sidebarLinks" :userData="userData" :edit-profile="navigateToEditProfile" />
    <div class="flex flex-col w-full">
      <!-- top navbar -->
      <ReNavbar :logo="require('@/assets/images/logo/logo-light-icon.png')" />
      <div class="p-3 h-screen overflow-auto">
        <!-- containerD -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarLinks from "../util/sidebarlinks.js";
import ReNavbar from "./components/Common/ReNavbar.vue";
import ReSidebar from "./components/Common/ReSidebar.vue";
export default {
  name: "MainContainer",
  components: {
    ReNavbar,
    ReSidebar,
  },
  data: () => ({
    sidebarLinks: sidebarLinks,
    userData: {
      name: "",
      email: "",
      image: "",
    },
  }),
  methods: {
    setAppUser() {
      const user = localStorage.getItem("user");
      if (user) {
        this.userData = JSON.parse(user);
      } else {
        this.userData = { name: "", email: "", image: "" };
      }
    },
    updateAppUser() {
      this.setAppUser();
    },
    navigateToEditProfile() {
      this.$router.push("/edit-profile");
    },
  },
  mounted() {
    this.setAppUser();
    // window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("storage", this.updateAppUser);
    window.addEventListener("user-updated", this.updateAppUser);
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("storage", this.updateAppUser);
    window.removeEventListener("user-updated", this.updateAppUser);
  },
};
</script>
